import * as React from 'react';
import './Overview.css';
import { ClassNames } from '../../_helpers/ClassNames';
import OverviewItem from './OverviewItem';

export type OverviewProps = OverviewDto;

export class Overview extends React.Component<OverviewProps> {
	constructor(props: OverviewProps) {
		super(props);
	}

	render() {
		const { Projects, OneColumn } = this.props;

		return (
			<div
				className={ClassNames('overview', '', '')}
				data-one-column={OneColumn}
			>
				<section className={ClassNames('overview', 'content')}>
					{Projects.map((p) => (
						<OverviewItem key={p.UID} {...p} OneColumnLayout={OneColumn} />
					))}
				</section>
			</div>
		);
	}
}
export default Overview;



// WEBPACK FOOTER //
// ./src/Components/Overview/Overview.tsx